export * from './archivado/seguimiento-archivado.component';
export * from './proveido/seguimiento-proveido.component';
